import * as Icons from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { HOW_IT_WORKS } from "@/lib/siteData";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative bg-gradient-subtle py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mx-auto max-w-3xl text-center">
          <span className="mb-4 inline-block rounded-full bg-accent px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-foreground">
            How It Works
          </span>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            From launch to lasting control in three simple steps
          </h2>
          <p className="mt-5 text-base text-muted-foreground md:text-lg">
            We handle the hard part. You get an effortless way to keep everything current.
          </p>
        </Reveal>

        <StaggerGroup className="relative mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* connector line */}
          <div className="pointer-events-none absolute left-0 right-0 top-[52px] hidden h-px bg-gradient-to-r from-transparent via-border to-transparent md:block" />
          {HOW_IT_WORKS.map((s) => {
            const Icon = Icons[s.icon] || Icons.Circle;
            return (
              <StaggerItem key={s.step}>
                <div className="group relative flex h-full flex-col rounded-3xl border border-border bg-card p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-card">
                  <div className="flex items-center justify-between">
                    <div className="relative grid h-14 w-14 place-items-center rounded-2xl bg-gradient-navy shadow-card transition-transform duration-300 group-hover:scale-105">
                      <Icon className="h-6 w-6 text-navy-foreground" />
                    </div>
                    <span className="font-display text-5xl font-bold text-secondary">{s.step}</span>
                  </div>
                  <h3 className="mt-6 font-display text-xl font-semibold text-navy">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                  <div className="mt-6 h-1 w-full overflow-hidden rounded-full bg-secondary">
                    <div className="h-full w-0 rounded-full bg-gradient-blue transition-all duration-700 group-hover:w-full" />
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};
